import { injectable } from "inversify";
import AuthRepository from "../../../domain/repositories/AuthRepository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../../domain/entities/ErrorEntity";
import UserEntity from "../../../domain/entities/UserEntity";
import LoginWithUserAndPasswordApiImpl from "./api/LoginWithUserAndPasswordApiImpl";
import GetCurrentUserApiImpl from "./api/GetCurrentUserApiImpl";
import LogOutApiImpl from "./api/LogOutApiImpl";

@injectable()
export default class AuthRepositoryImpl implements AuthRepository {
    getCurrentUser = (): Promise<UserEntity | null> => GetCurrentUserApiImpl();
    loginWithEmailAndPassword = (email: string, password: string): Promise<Either<ErrorEntity, UserEntity>> => LoginWithUserAndPasswordApiImpl(email, password);
    logout = (): Promise<Either<ErrorEntity, void>> => LogOutApiImpl();

}